import {
  GetSectionPostOptionsProps,
  PostOption,
  SectionPostOptions,
} from '../../../helpers/types'

/* getNativeStoryModule takes a post component's post options and converts them to a dynamic module Component */
export const getNativeStoryModule = ({
  module,
}: GetSectionPostOptionsProps): SectionPostOptions => {
  let cta = module?.igNativeStoryLinkAdCtaOption
  if (typeof cta === 'object')
    cta = (module?.igNativeStoryLinkAdCtaOption as PostOption)?.selected?.title
  if (!cta) cta = ''

  return {
    cta: cta,
    ctaUrl: module?.igNativeStoryLinkAdWebsiteUrlOption || '',
  }
}
